import React from 'react';

/**
* Renders animated skeleton placeholders for a list of problems while data loads.
* @example
* ProblemListSkeleton()
* <div className="animate-pulse space-y-4">...</div>
* @returns {JSX.Element} Placeholder layout for the problem list.
**/
const ProblemListSkeleton = () => {
  return (
    <div className="animate-pulse space-y-4">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="bg-background-secondary rounded-lg p-4 border border-border-primary">
          <div className="flex items-center gap-4">
            {/* Number */}
            <div className="w-12 h-6 bg-background-tertiary rounded" />
            
            {/* Title */}
            <div className="flex-1">
              <div className="h-5 bg-background-tertiary rounded w-3/4 mb-2" />
              <div className="flex gap-2">
                <div className="h-4 bg-background-tertiary rounded w-16" />
                <div className="h-4 bg-background-tertiary rounded w-20" />
              </div>
            </div>
            
            {/* Difficulty */}
            <div className="w-20 h-6 bg-background-tertiary rounded" />
            
            {/* Stats */}
            <div className="w-24 h-6 bg-background-tertiary rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProblemListSkeleton;
